<template>
  <div>
    <TermsPopUp
      ref="terms"
      :class="termsFlag"
      @termsToggleChange="termsToggleChange"
      :appAgreementId="appAgreementId"
    />
    <div class="app-wrap">
      <div class="app-header app-header-content" style="top: 0;">
      <img src="@/assets/img/bi_order_app_v.png" class="app-header-bi">
      <div class="app-header-end">
        <span @click="appClose()">종료</span>
      </div>
    </div>
      <div class="agree-wrap" style="margin-bottom: 80px">
        <div class="title">
          <p>서비스 이용을 위한<br><span class="fc-4c3bc5 fwb">약관동의가 필요합니다</span></p>
        </div>
        <div class="agree-group">
          <ul class="agree-list">
            <li v-for="(list) in agreeList" :key="list.appAgreementId">
              <label :for="list.appAgreementId">
                <input type="checkbox" :id="list.appAgreementId" v-model="checkList" :value="list.appAgreementId">
                <span></span>
                <span class="txt">
                  <span class="txt-imp">{{ essentialFlag(list) }} </span>
                  <span>{{ list.name }}</span>
                </span>
              </label>
              <!-- <a :href="getLink(index)">보기</a> -->
              <span @click="termsDetailOpen" :data-agree="list.appAgreementId">보기</span>
            </li>
          </ul>
        </div>
      </div>
      <button class="full-login-btn" @click="nextComponent" :disabled="!allCheck">
        다음
      </button>
    </div>
  </div>
</template>

<script lang="js">
import service from '@/backend/modnpay_app_api'
import { THROW_APP_ERROR, THROW_APP_LOGIN_OVER_LAP } from '@/router'
import AppSignUpHeader from '@/components/Header/AppSignUpHeader.vue'
import ProgressBar from '@/components/SignUp/ProgressBar.vue'
import TermsPopUp from '@/components/Terms/TermsPopUp.vue'
/* eslint-disable eqeqeq */
export default {
  components: {
    AppSignUpHeader,
    ProgressBar,
    TermsPopUp
  },
  data () {
    return {
      headerText: '시작하기',
      termsToggle: false,
      allCheck: false,
      checkList: [], // 선택한 체크박스 리스트
      checkLength: 0, // 체크박스 길이
      agreeList: [], // 약관 리스트
      appAgreementId: 0 // 약관 식별자
    }
  },
  created () {
    this.agreementList()
  },
  methods: {
    selectCheckAll () { // 전체선택
      this.allCheck = !this.allCheck
      this.checkList = []
      if (this.allCheck) {
        for (let i = 0; i < this.checkLength; i++) {
          this.checkList.push(this.agreeList[i].appAgreementId)
        }
      }
    },
    updateCheckAll () { // 전체가 선택 되었을때
      this.allCheck = this.checkList.length === this.agreeList.length
    },
    nextComponent () {
      this.$emit('nextComponent', { componentName: 'AppSignUpAuthPage' })
    },
    termsToggleChange () { // 약관 팝업
      this.termsToggle = !this.termsToggle
    },
    getLink (index) {
      switch (index) {
        case 0:
          return 'https://partner.modnpay.kr/policyView?seq=5'
        case 1:
          return 'https://partner.modnpay.kr/policyView?seq=6'
        case 2:
          return 'https://partner.modnpay.kr/policyView?seq=14'
        case 3:
          return 'https://partner.modnpay.kr/policyView?seq=12'
        case 4:
          return 'https://partner.modnpay.kr/policyView?seq=13'
        case 5:
          return 'https://partner.modnpay.kr/policyView?seq=7'
        default:
          return undefined
      }
    },
    termsDetailOpen () { // 약관 상세
      // window.location.href = this.getLink(index)
      this.appAgreementId = Number(event.target.getAttribute('data-agree'))
      this.$nextTick(() => {
        this.$refs.terms.agreementDetail()
      })
      this.termsToggleChange()
    },
    async agreementList () { // 약관 목록 조회
      const req = {
        agreementType: 1
      }
      const { data } = await service.agreementList(req)
      const code = data.resultCode

      if (code == 0) {
        this.agreeList = data.agreementList
        this.checkLength = data.agreementList.length
      } else if (code == 15033) {
        THROW_APP_LOGIN_OVER_LAP()
      } else {
        THROW_APP_ERROR()
      }
    }
  },
  watch: {
    // 체크리스트 길이 감시
    checkList () {
      this.updateCheckAll()
    },
    termsToggle () {
      if (this.termsToggle) {
        document.querySelector('body').style.overflow = 'hidden'
      } else {
        document.querySelector('body').removeAttribute('style')
      }
    }
  },
  computed: {
    essentialFlag () {
      return (list) => list.optionFlag === 0 ? '(필수)' : '(선택)'
    },
    termsFlag () { // 약관을 눌렀을때 position top 조정
      return this.termsToggle ? 'show' : ''
    }
  }
}
</script>

<style>

</style>
